// extracted by mini-css-extract-plugin
module.exports = {"opacity":"useFadeOutWhen_opacity__3xO8N"};